import React, { useState } from 'react'

import { F0TimelineRow } from '@factorialco/f0-react'
import type { F0TimelineRowTaskProps } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

import { mapTimelineStatus } from './helpers'
import type { ApprovalsV2ApprovalTimelineEntryFragment } from 'generated/resources/graphql'

interface MultiTaskGroupProps {
  entries: ApprovalsV2ApprovalTimelineEntryFragment[]
  buildEntryItem: (
    entry: ApprovalsV2ApprovalTimelineEntryFragment,
    idx: number,
    isLast: boolean
  ) => F0TimelineRowTaskProps
  alert?: React.ReactNode
  isLast: boolean
}

// `rejected` entries are terminal and rendered as completed (see `mapTimelineStatus`).
// Treat them as completed when computing the multi-task group header state so that
// a group containing only rejected entries does not render as "future/not-started".
const isTerminal = (status: string) => status === 'completed' || status === 'rejected'

const MultiTaskGroup = ({ entries, buildEntryItem, alert, isLast }: MultiTaskGroupProps) => {
  const hasCurrent = entries.some((e) => e.status === 'running' || e.status === 'changesrequested')
  const allCompleted = entries.every((e) => isTerminal(e.status))
  const [expanded, setExpanded] = useState(!allCompleted)

  const groupStatus = mapTimelineStatus(
    allCompleted ? 'completed' : hasCurrent ? 'running' : 'future'
  )

  const items = entries.map((entry, idx) => buildEntryItem(entry, idx, idx === entries.length - 1))

  return (
    <>
      <F0TimelineRow
        status={groupStatus}
        title={i18n.t('approvals_v2.timeline.tasks_count', { count: '' }).trim()}
        taskCount={entries.length}
        completedCount={entries.filter((e) => isTerminal(e.status)).length}
        expanded={expanded}
        onExpandToggle={() => setExpanded((prev) => !prev)}
        items={items}
        isLast={isLast}
      />
      {alert}
    </>
  )
}

export default MultiTaskGroup
